import Navbar from "@/components/kenjosset/Navbar"
import Flash from "@/components/kenjosset/Flash"
import Footer from "@/components/kenjosset/Footer"
import PhotoEditor from "@/components/kenjosset/PhotoEditor"
import type { KenjossetChrome, KenjossetPhoto } from "@/components/kenjosset/types"

interface Props {
  chrome: KenjossetChrome
  images: KenjossetPhoto[]
}

// Faithful React port of kenjosset/portfolio.html.slim: the gallery grid, fed by
// the store's StorePhoto records — or, while it has none, by the server-side
// lexicographic listing of app/assets/images/kenjosset/portfolio.
export default function Portfolio({ chrome, images }: Props) {
  return (
    <div className="bg-light min-h-screen">
      <Navbar chrome={chrome} active="portfolio" />

      <PhotoEditor variant="gallery" photos={images}>
        <div className="min-h-[calc(100vh-500px)] h-full">
          <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 pt-12">
            {images.map((image) => (
              <img
                key={image.id ?? image.url}
                src={image.url}
                alt={image.alt}
                loading="lazy"
                className="w-full h-64 md:h-48 object-cover object-center"
              />
            ))}
          </div>
        </div>
      </PhotoEditor>

      <Footer chrome={chrome} />
      <Flash />
    </div>
  )
}
